import type {i18n} from 'i18next';
import {getFileNames} from './plugins/getFileNames';

export function registerSharedTranslations(i18nInstance: i18n) {
  const {languages, namespaces, modules} = getFileNames();

  for (const language of languages) {
    for (const namespace of namespaces) {
      try {
        // const modulePath = `../../../../assets/locales/${language}/${namespace}.json`;
        const matchingKey = Object.keys(modules).find(key =>
          key.includes(`/locales/${language}/${namespace}.json`),
        );

        if (matchingKey) {
          const module = modules[matchingKey] as Record<string, unknown> | {default: Record<string, unknown>};
          const translations = 'default' in module ? module.default : module;

          if (translations) {
            i18nInstance.addResourceBundle(
              language,
              namespace,
              translations,
              true, // deep merge
              true, // overwrite
            );
          }
        }
      } catch (error) {
        console.warn(
          `Failed to register ${language}/${namespace} shared translations:`,
          error,
        );
      }
    }
  }
}

export type {i18n};
